export default {
	common: {
		noMore: '没有更多了',
		noEmpty: '必传',
		copySuccess: '复制成功',
		copyFail: '复制失败',
		search: '搜索',
		remark: '备注',
		commit: '提交',
		status: '状态',
		revoke: '撤销',
		cancel: '取消',
		confirm: '确认',
		getbtn: '领取',
		isgetbtn: '领取完毕',//已领取
		selectTime: '选择时间',
		selectDate: '选择日期',
		uploadImage: '图片上传',
		uploadVideo: '视频上传',
		activity: '活动',
		problem: '问题',
		money: '金额',
		reply: '回复',
		other: '其他',
		send: '发送',
		copy: '复制',
		view: '查看',
		next: '下一步',
		feedback: '我要反馈',
		enter: '请输入',
		loading: '加载中...',
		searchkey: '请输入搜索关键词',
		back: '返回',
		download: '下载',
		detail: '详情',
		mUnit: '￥',
		thousand: '千',
		tenThousand: '万',
		tenMillion: '千万',
		billion: '亿',
		hundredBillion: '千亿',
		trillions: '万亿',
		quadrillions: '千万亿',
	},
	upload: {
		label: '上传',
		loading: '上传中...',
		success: '上传成功',
		fail: '上传失败',
		sizeTips: '文件大小不能超过 {size} M',
	},
	menu: {
		home: '首页',
		news: '最热门资讯',
		personal: '个人中心',
		coupon: '十万抵扣券',
		pay: '支付',
		clauseUser: '用户隐私协议',
		clauseService: '隐私政策',
		about: '关于我们',
		contact: '联系我们',
		refund: '退款协议',
		pcdownload: 'PC下载',
		download: '下载',
		activity: 'GM소식'
	},
	login: {
		name: '账号',
		pass: '密码',
		nameTips: '请填写用户名',
		passTips: '请填写密码',
		submitBtn: '提交',
		accountTitle: '账密登录',
		thirdTitle: '第三方登录',
		googleLogin: 'google登录'
	},
	home: {
		tips:'GM 官方kakao：GM game',
		slogans:'모든 게임 50% 할인되는 정보 app',
		news: '最热门资讯',
		recommend: '最新福利资讯',
		recommendGame: '推荐游戏',
		recommendDesc: '官方推荐好游',
		hotGame: '热门游戏',
		hotDesc: '最火热门游戏',
		gameDownload: '游戏下载',
		pcDownload: 'PC下载',
		downloadUrl: '下载地址',
		activity: '活动',
		introduction: '攻略',
		offlineActivity: '线下活动',
		openService: '开服时间',
		releaseTime: '发布时间',
		gameNotice: '游戏公告',
		prebookGame: '新游预约',
		prebookDesc: '最新公开，新游首发',
		guidesTitle: '添加教程',
		btnText: '激活10万韩币',
		guidesText:'完成下方步骤可获得10万元韩币抵扣券',
		newstotal: '当前有 {num} 篇攻略',
		gamePlay: '开始游戏',
		couponRules: '使用说明',
		serviceTime: '时间',
		serviceGame: '游戏',
		serviceList: '列表',
		serviceMoney: '月充值金额',
		serviceCoin: '可领取GM币',
		serviceBtn: '达标状态',
		serviceTotal: '当月已充值',
		notStandard: '未达标',
		isStandard: '已达标',
		rankRules: '活动规则',
		rankRule1: '使用GM版本结算的费用才计入此充值(不含代金券/GM币)',
		rankRule2: '月充值达到对应充值金额后方可联系GM50领取奖励',
		rankRule3: 'GM币不可转移至其他账号',
		rankRule4: '每月1日开始计算,当月最后一天的23:59:59截止',
		rankRule5: '此活动是游戏以外内容,不支持退款',
		rankRule6: '本月可手动领取上月充值奖励',
		rankRule7: '仅按照上月最高达标档位领取,不可重复领取低档位奖励'
	},
	pay: {
		title: '充值中心',
		orderMoney: '订单金额',
		allCoupon: '全额代金券',
		halfCoupon: '半额代金券',
		total: '合计',
		discount: '折扣',
		paybtn: '支付',
		authConfirm: '去实名',
		authCancel: '已实名',
		payJumpTitle: '支付跳转提示',
		payJumpText: '将离开此页面，是否确认去支付？',
		payRecharge: '立即充值',
		recharge: '充值',
		gorecharge: '前往充值',
		rechargeMoney: '充值金额',
		rechargeTitle: '选择充值金额',
		rechargePlaceholder: '请输入充值金额',
		rechargeDiscount: '首充赠送双GM兑换券',//'首充{num}倍',
		tipsInputRecharge: '请重新选择或输入充值金额~',
		goodMoney: '商品价格',
		discountCoupon: '抵扣券',
		gmCoin: 'GM币',
		paygmCoin: '全额GM币',
		payType: '支付方式',
		discountMoney: '已优惠',
		maxDiscountTips: '已推荐最优惠方案',
		discountTitle: '请选择抵扣券',
		noUseDiscount: '不使用抵扣券',
		expTime: '到期时间',
		percentDiscount: '100%抵扣券',
		halfPercentDiscount: '50%抵扣券',
		onlyForthisGame: '仅限本游戏',
		fullReduction: '满{num}可用',
		gmCoinTitle: 'GM币使用',
		paygmCoinTitle: '全额GM币使用',
		payTypeTitle: '选择支付方式',
		gmCoinTips: 'GM币可用于GM系列礼包兑换',
		paygmCoinTips: '全额GM币可用于GM系列礼包兑换',
		allGMCoin: '现有GM币',
		allPayGMCoin: '现有全额GM币',
		useGMCoin: '消耗GM币',
		usePayGMCoin: '消耗全额GM币',
		remainGMCoin: '剩余GM币',
		remainPayGMCoin: '剩余全额GM币',
		selectPayTitle: '选择支付方式',
		gmCoinPlaceholder: '请输入GM币（{num}起）',
		paygmCoinPlaceholder: '请输入全额GM币（{num}起）',
		freeGetGM: '免费获得',
		needPayTips: '您输入的GM币和抵扣券叠加使用后，需另支付金额且不足{num}元，请你重新输入使用GM币或者重新选择抵扣券～',
		detail: '详情',
		payTypeTips: '抵扣券和GM币不能同时用',
		payMaxLimit: '最高抵扣{num}',
		payLimitTips: '没有剩余金额能用GM币抵扣啦～',
		remainNums: '余量:{num}'
	},
	payments: {
		settleAmount: '结算金额',
		helpTips1: '如有支付问题请联系GM',
		helpTips2: '需要提供支付编号和截图',
		allPays: '所有支付方式',
		privacyTips: '继续支付代表接受',
		privacyPolicy: '使用条款',
		privacyAgreement: '隐私协议',
		paybtn: '支付',
		commission: '手续费',
		totalMoney: '合计金额'
	},
	privacy: '继续支付代表接受{Policy}&{Agreement}',
	personal: {
		platId: '平台ID',
		platCoin: '平台币',
		payPlatCoin: '全额GM币',
		myPlatCoin: '半价GM币',
		myPlatCoupons: 'GM抵扣券',
		loginBtn: '登录',
		loginOut: '退出登录',
		googleEmail: 'google邮箱',
		tipsLogin: '请您先登录～',
		commonUser:'普通用户',
		vipDetail:'查看特权',
		vipPage:'VIP信息',
		signedInfo: '半价折扣GM币',
		gmdesc1: '全额折扣GM币：如果您通过官方套餐为游戏内的支付商品充值，您可以使用“全额折扣GM币”全额减免充值金额。',
		gmdesc11: '（但是，如果持有的全额折扣GM硬币数量未达到减免金额，则无法使用。）',
		gmdesc2: 'GM代金券：可在GM商店兑换物品，不可抵扣充值',
		gmdesc3: '满减券：满足结算金额后减免对应额度',
		orderTitle: '订单中心',
		join: '查看'
	},
	orders: {
		title: '订单中心',
		total: '合计',
		desc: '默认展示今年充值记录',
		games: '游戏',
		payTime: '支付时间',
		plats: '全部渠道',
		money: '金额',
		coupon: '优惠券',
		realpay: '实际充值',
		exchange: '切换',
		searchGame: '筛选游戏',
		gamePlace: '请输入游戏名',
		beginTime: '开始时间',
		endTime: '结束时间',
		all: '全部',
		gameId: '游戏ID',
		platName: '平台',
		platOrder: '支付订单',
		userId: '用户ID',
		roleId: '角色ID',
		roleName: '角色名称',
		serviceName: '区服名'
	},
	footer: {
		aboutus: '公司介绍',
		contact: '客服支持',
		service: '隐私政策',
		refund: '退款协议',
		userService: '用户协议',
		telLabel: '电话号码',
		telValue: '01088727088',
		licenseNumLabel: '营业执照号',
		licenseNumValue: '387-81-02165',
		companyLabel: '公司名称',
		companyValue: '桂圆',
		legalPersonLabel: '代表名',
		legalPersonValue: 'YU CHAOSHUYI',
		emailLabel: '邮箱',
		emailValue: "supergmgame{'@'}gmail.com",
		bankLabel: '银行账号',
		bankValue: 'KEB HANA BANK 189-910052-14504',
		businessNumLabel: '邮购业务编号',
		businessNumValue: '제2023-서울강남-03332호',
		addressLabel: '地址',
		addressValue: '서울특별시 강남구 영동대로 602,6층 에이치41(삼성동,미켈라 107)',
		support: '© 2023 Powered by GM',
		useManual: '使用说明',
		gmRules: 'GM货币指南',
		levelTips: '距离下一个 VIP 等级还剩下 {nums}经验。',
		ruleTips1: '1、每天签到可获得最少200个GM币，VIP等级越高签到获得的GM币越多。',
		ruleTips2: '2、通过使用GM版本结算可以提升VIP等级。',
		ruleTips3: '3、普通版本结算可获取1%GM币，GM版本结算可获取2%GM币',
		ruleTips4: '4、GM币可在GM版本中抵扣充值(1:1)',
		ruleTips5: '5、GM 교환 쿠폰可在GM商城兑换道具礼包。'
	},
	iosdown: {
		ranking: '排行榜',
		rankNum: '第3名',
		age: '年龄',
		ageUnit: '岁',
		ageLevel: '年龄分级',
		other: '其他',
		scoreNum: '19万个评分',
		scoreFull: '满分5分',
		quesTips: '出现下列问题可以点击此处进行解决',
		appQuit: 'APP闪退',
		unInstall: '无法安装',
		blackIcon: '图标变黑',
		developMode: '需要启用开发者模式',
		comments: '评分及评论',
		suggest: '投诉建议',
		newFunc: '新功能',
		version: '版本1.0.2',
		info: '信息',
		price: '价格',
		free: '免费',
		size: '大小',
		type: '类别',
		language: '语言',
		korea: '韩语',
		privacy: '隐私政策',
		compatible: '兼容性',
		compatibleDes: '需要 iOS 13.0 或更高版本。与 iPhone、iPad 和 iPod touch 兼容。',
		disclaimer: '免责声明',
		disclaimerDes: '本⽹站仅为开发者提供App的下载和安装内测托管，App内的内容和运营相关事项由App开发者负责，与本⽹站⽆关',
		btn1: '苹果授权中,在弹框中点击允许',
		btn2: '点击弹框中的【打开】按钮进行安装',
		btn3: '该 UDID 进入延迟生效',
		developTitle: '【开发者模式】开启教程',
		developNext: '滑动查看下一步',
		developEnd: '教程结束，滑动返回第一步',
		developOpen: '我已开启，以后不要提示我',
		SafariTips: '请在移动端并且ios中Safari打开',
		findAppError: '无法找到 App ！',
		networkError: '网络错误，请稍后重试！',
		ParamsError: '自定义参数错误，请检查入参！',
		signStatus: '当前签名状态',
		signStep: '当前签名进度',
		signFail: '签名失败',
		failTips: '建议引导用户下载临时版，或者使用云游戏版',
		down1: '临时版下载链接',
		down2: '云游戏版打开链接',
		fixStatus: '修复状态',
		fixBtn: '开始修复',
		developBtn: '启用开发者模式教程',
		fixCon1: '亲爱的用户，如您的APP遇到如下情况：',
		fixCon2: '• APP图标变成黑色无法打开',
		fixCon3: '• 提示无法安装此APP／打开后闪退',
		fixCon4: '可使用APP修复助手，{str}，根据操作提示获取UDID，即可完成修复。',
		fixCon4Str: '点击开始修复按钮',
		fixCon5: '修复完成1分钟后，删除无法使用的APP，重新下载即可正常使用。若还是无法使用，请{str}处理。',
		fixCon5Str: '联系客服',
		developCon1: '若您在打开App时，弹出下述弹框：',
		developCon2: '• 『需要启用开发者模式』',
		developCon3: '请{str}，根据教程进行启用。一台设备只需要启用一次，后续下载任意App都不需要再启动。',
		developCon3Str: '点击下面的【启用开发者模式教程】',
		developCon4: '（启用开发者模式不会对您的设备产生任何安全性影响）',
		notIOS: '苹果应用不支持安卓设备！'
	}
}